import { getNotAllowedPhones } from 'app/services/env.service';
import { ValidationObject } from 'app/services/validation.service';
import { FormsEnum } from 'app/shared/enums';
import { ValidatorDataInterface } from 'app/shared/interfaces/ValidatorData.interface';

const isPhoneNotAllowed = (phone: string) => {
  const phoneNotAllowed = getNotAllowedPhones;

  return phoneNotAllowed.includes(phone);
};

export function isPhoneNumberWithLandlinePrefix(phoneNumber: string) {
  const landlinePrefixes = [
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '22',
    '23',
    '24',
    '25',
    '29',
    '32',
    '33',
    '34',
    '41',
    '42',
    '43',
    '44',
    '46',
    '47',
    '48',
    '52',
    '54',
    '55',
    '56',
    '58',
    '59',
    '61',
    '62',
    '63',
    '65',
    '67',
    '68',
    '71',
    '74',
    '75',
    '76',
    '77',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '89',
    '91',
    '94',
    '95',
  ];

  const sanitizedNumber = phoneNumber.replace(/\D/g, '');
  const prefix = sanitizedNumber.slice(0, 2);

  return landlinePrefixes.includes(prefix);
}

export function isPhoneNumberWithSameDigits(phoneNumber: string) {
  return /^(\d)\1{8}$/.test(phoneNumber);
}

export function doesPhoneNumberStartWith0(phoneNumber: string) {
  return phoneNumber.startsWith('0');
}

export const validatePhoneNumberIsAllowed = (data: ValidatorDataInterface) => {
  const forms = [
    FormsEnum.CalculationForm,
    FormsEnum.CheckoutForm,
    FormsEnum.TravelCheckoutForm,
  ];
  const { formName } = data;

  return {
    key: 'not_allowed_phone_number',
    valid:
      !forms.includes(formName) || !isPhoneNotAllowed(data.value.toString()),
  };
};

export function isValidPhoneNumber(phoneNumber: string) {
  const reg = /^[0-9]{9}$/;

  return reg.test(phoneNumber) && !isPhoneNotAllowed(phoneNumber);
}

export default function validatePhoneNumber(
  data: ValidatorDataInterface
): ValidationObject {
  return {
    key: 'invalid_phone_number',
    valid: isValidPhoneNumber(data.value.toString()),
  };
}
